(function () {
  angular.module('MktzapApp.Factories')
    .factory('CustomDocumentsService', CustomDocumentsService);

  CustomDocumentsService.$inject = ['$resource'];

  function CustomDocumentsService ($resource) {
    return $resource(apiUrl + '/custom-documents/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: false },
      update: { method: 'PATCH', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      checkIfExists: { url: apiUrl + '/custom-documents/check', method: 'POST', isArray: true },
      download: { url: apiUrl + '/custom-documents/download', method: 'POST', isArray: false }
    });
  }
})();
